import { render } from "./DeliveryNumberChangeModal.vue?vue&type=template&id=18ec2eba"
import script from "./DeliveryNumberChangeModal.vue?vue&type=script&lang=js"
export * from "./DeliveryNumberChangeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__